module.exports = __webpack_public_path__ + "static/media/scissors.9f7903ea.svg";